{
  "Your Stripe account, your branding, your price": "あなたのStripeアカウント、ブランディング、価格で",
  "Our fee is just US $1.50 per ticket sold (introductory offer)": "当社の手数料は、チケット1枚の販売につきわずかUS $1.50です（導入記念価格）",
  "All countries and 31 currencies supported": "すべての国と31の通貨に対応",
  "A fixed price, or let buyers choose the price": "固定価格、または購入者が価格を選択",
  "Coupons and other Stripe features": "クーポンなどのStripeの機能",
  "Currency": "通貨",
  "Loading currencies…": "通貨を読み込んでいます…",
  "Amount": "金額",
  "Fee": "手数料",
  "{code} - {name} (No auto-conversion)": "{code} - {name}（自動換算なし）",
  "Search currency...": "通貨を検索…",
  "Add currency": "通貨を追加",
  "Single day {price} (24h access)": "1日券：{price}（24時間視聴可能）",
  "All {days} days {price}": "全{days}日間：{price}",
  "Livestream {price} (no replay)": "ライブ配信：{price}（録画なし）",
  "Livestream {price}": "ライブ配信：{price}",
  "Livestream + Replay {price}": "ライブ配信＋録画：{price}",
  "+ video download add-on {price}": "＋動画のダウンロード（オプション）：{price}",
  "+ service & processing fee at checkout": "＋決済時にサービス料・決済手数料",
  "Video download {price} (live-only event — no replay)": "動画のダウンロード：{price}（ライブ配信のみのイベントのため録画なし）",
  "Nothing (live-only event with downloads off)": "なし（ライブ配信のみのイベントで、ダウンロードはオフ）",
  "Replay {price}": "録画：{price}",
  "Replay + download": "録画＋ダウンロード",
  "What buyers will see": "購入者に表示される内容",
  "Before & during the event: {items}": "イベント前・イベント中：{items}",
  "After the event: {items}": "イベント後：{items}",
  "Unlink Stripe Account": "Stripeアカウントの連携を解除",
  "Are you sure you want to unlink your Stripe account? This will disable ticket sales for this event.": "Stripeアカウントの連携を解除してもよろしいですか？このイベントのチケット販売が無効になります。",
  "Failed to unlink Stripe account. Please try again.": "Stripeアカウントの連携を解除できませんでした。もう一度お試しください。",
  "Sell tickets": "チケットを販売",
  "Couldn't load currencies": "通貨を読み込めませんでした",
  "Check your connection and try again.": "接続を確認して、もう一度お試しください。",
  "Guests pay to watch, and the money goes straight to your Stripe account.": "ゲストは料金を支払って視聴し、売上はあなたのStripeアカウントに直接入金されます。",
  "Tickets for rooms": "ルームのチケット",
  "Connect Stripe account": "Stripeアカウントを接続",
  "Copy link to connect Stripe": "Stripe接続用リンクをコピー",
  "Send it to the Stripe account's owner.": "Stripeアカウントの所有者に送ってください。",
  "Not your Stripe account? Send the link to its owner so they can connect it.": "ご自身のStripeアカウントではありませんか？所有者にリンクを送って、接続してもらってください。",
  "Stripe fees, refunds and chargebacks are the connected account holder's responsibility. Need help setting up? Ask us in the support chat.": "Stripeの手数料、返金、チャージバックは、接続したアカウントの所有者の責任となります。設定にお困りの場合は、サポートチャットでお問い合わせください。",
  "Stripe account connected": "Stripeアカウントを接続しました",
  "Stripe dashboard": "Stripeダッシュボード",
  "Refresh": "更新",
  "Unlink": "連携を解除",
  "How guests pay": "ゲストの支払い方法",
  "Disable Pay-Per-View": "ペイパービューを無効にする",
  "Use Existing Stripe Price": "既存のStripe価格を使用",
  "Custom Price (Fixed)": "カスタム価格（固定）",
  "Customer Chooses Price": "購入者が価格を選択",
  "Choose how guests pay": "ゲストの支払い方法を選択",
  "Select Stripe Price": "Stripe価格を選択",
  "price|None": "なし",
  "Custom Prices": "カスタム価格",
  "This event is live-only, so the ticket includes the livestream only (no replay).": "このイベントはライブ配信のみのため、チケットにはライブ配信のみが含まれます（録画なし）。",
  "The ticket includes the livestream.": "チケットにはライブ配信が含まれます。",
  "The ticket includes the livestream and the replay.": "チケットにはライブ配信と録画が含まれます。",
  "Set prices for each currency. First currency becomes the default.": "通貨ごとに価格を設定してください。最初の通貨がデフォルトになります。",
  "Sell single-day tickets": "1日券を販売",
  "Your price above is the All-Days ticket. Set one price per day below — buyers choose which day. Single-day access lasts 24 hours from that day's scheduled start time.": "上の価格は全日程のチケットの価格です。下で1日ごとの価格を設定すると、購入者は日付を選べます。1日券の視聴期間は、その日の開始予定時刻から24時間です。",
  "Sell video download": "動画のダウンロードを販売",
  "Buyers can add the downloadable video to any ticket for this amount.": "購入者は、この金額でどのチケットにも動画のダウンロードを追加できます。",
  "After the event it's sold on its own since this event is live-only.": "このイベントはライブ配信のみのため、イベント後は単体で販売されます。",
  "After the event it's sold as Replay + Download.": "イベント後は「録画＋ダウンロード」として販売されます。",
  "Single-day buyers can only download their day.": "1日券の購入者は、その日の動画のみダウンロードできます。",
  "+ Set a different replay price after the event (optional)": "＋イベント後の録画の価格を別に設定（任意）",
  "Replay price after the event": "イベント後の録画の価格",
  "Use ticket price": "チケットの価格を使用",
  "Once the event is over, new buyers pay this instead of the ticket price. You can also change any price at any time.": "イベント終了後、新たな購入者はチケットの価格ではなくこの価格を支払います。どの価格もいつでも変更できます。",
  "Add fees at checkout (buyers pay the fees)": "決済時に手数料を追加（購入者が負担）",
  "Buyers pay one combined EventLive + card processing fee on top of your price, so you receive the full amount you set (card fees are estimated at the standard rate — unusual cards may vary slightly).": "購入者は、あなたが設定した価格に加えて、EventLiveの手数料とカード決済手数料をまとめた手数料を支払うため、設定した金額を全額受け取れます（カード手数料は標準料率で見積もっているため、一部のカードではわずかに異なる場合があります）。",
  "Fees are currently deducted from your price: the EventLive fee shown above plus Stripe's card processing fee.": "現在、手数料は価格から差し引かれます。上に表示されているEventLiveの手数料と、Stripeのカード決済手数料です。",
  "Default Price Suggestions": "デフォルトの提案価格",
  "These are suggested amounts customers will see, but they can enter any amount they wish.": "購入者に表示される提案金額です。購入者は好きな金額を入力することもできます。",
  "More settings": "その他の設定",
  "Upload logo in Profile Settings": "プロフィール設定でロゴをアップロード",
  "Invite free viewers in Guest List": "ゲストリストから無料の視聴者を招待",
  "Customize event branding": "イベントのブランディングをカスタマイズ",
  "Enable payment emails in Stripe": "Stripeで支払いメールを有効にする",
  "Customize branding in Stripe": "Stripeでブランディングをカスタマイズ",
  "Credits Added Successfully": "クレジットを追加しました",
  "Thank You for Your Purchase!": "ご購入ありがとうございます！",
  "Your credits are ready to use. You can now:": "クレジットをご利用いただけるようになりました。次のことができます：",
  "You can now:": "次のことができます：",
  "Use your credits to unlock more events": "クレジットを使って、さらにイベントをアンロックする",
  "Check your available balance before your next purchase": "次回の購入前に、利用可能な残高を確認する",
  "Return to your events and keep editing": "イベントに戻って編集を続ける",
  "Invite guests to your event by sharing the event link or using the Guest List feature": "イベントリンクを共有するか、ゲストリスト機能を使ってゲストを招待する",
  "Open \"How to Go Live\" for a step-by-step guide": "「ライブ配信の方法」を開いて、手順を確認する",
  "Go live on the day of your event": "イベント当日にライブ配信を開始する",
  "Return to Event": "イベントに戻る",
  "View My Events": "イベント一覧を見る",
  "Afghanistan": "アフガニスタン",
  "Åland Islands": "オーランド諸島",
  "Albania": "アルバニア",
  "Algeria": "アルジェリア",
  "American Samoa": "米領サモア",
  "Andorra": "アンドラ",
  "Angola": "アンゴラ",
  "Anguilla": "アンギラ",
  "Antarctica": "南極",
  "Antigua and Barbuda": "アンティグア・バーブーダ",
  "Argentina": "アルゼンチン",
  "Armenia": "アルメニア",
  "Aruba": "アルバ",
  "Australia": "オーストラリア",
  "Austria": "オーストリア",
  "Azerbaijan": "アゼルバイジャン",
  "Bahamas": "バハマ",
  "Bahrain": "バーレーン",
  "Bangladesh": "バングラデシュ",
  "Belgium": "ベルギー",
  "Belize": "ベリーズ",
  "Benin": "ベナン",
  "Bermuda": "バミューダ",
  "Bhutan": "ブータン",
  "Bolivia": "ボリビア",
  "Bosnia and Herzegovina": "ボスニア・ヘルツェゴビナ",
  "Botswana": "ボツワナ",
  "Bouvet Island": "ブーベ島",
  "Brazil": "ブラジル",
  "British Indian Ocean Territory": "英領インド洋地域",
  "Brunei Darussalam": "ブルネイ",
  "Bulgaria": "ブルガリア",
  "Burkina Faso": "ブルキナファソ",
  "Burundi": "ブルンジ",
  "Cambodia": "カンボジア",
  "Cameroon": "カメルーン",
  "Canada": "カナダ",
  "Cape Verde": "カーボベルデ",
  "Cayman Islands": "ケイマン諸島",
  "Central African Republic": "中央アフリカ共和国",
  "Chad": "チャド",
  "Chile": "チリ",
  "China": "中国",
  "Christmas Island": "クリスマス島",
  "Cocos (Keeling) Islands": "ココス(キーリング)諸島",
  "Colombia": "コロンビア",
  "Comoros": "コモロ",
  "Congo": "コンゴ共和国(ブラザビル)",
  "Congo, The Democratic Republic of the": "コンゴ民主共和国(キンシャサ)",
  "Cook Islands": "クック諸島",
  "Costa Rica": "コスタリカ",
  "Cote D Ivoire": "コートジボワール",
  "Croatia": "クロアチア",
  "Cuba": "キューバ",
  "Cyprus": "キプロス",
  "Czech Republic": "チェコ",
  "Denmark": "デンマーク",
  "Djibouti": "ジブチ",
  "Dominica": "ドミニカ国",
  "Dominican Republic": "ドミニカ共和国",
  "Ecuador": "エクアドル",
  "Egypt": "エジプト",
  "El Salvador": "エルサルバドル",
  "Equatorial Guinea": "赤道ギニア",
  "Eritrea": "エリトリア",
  "Estonia": "エストニア",
  "Ethiopia": "エチオピア",
  "Falkland Islands (Malvinas)": "フォークランド諸島",
  "Faroe Islands": "フェロー諸島",
  "Fiji": "フィジー",
  "Finland": "フィンランド",
  "France": "フランス",
  "French Guiana": "仏領ギアナ",
  "French Polynesia": "仏領ポリネシア",
  "French Southern Territories": "仏領極南諸島",
  "Gabon": "ガボン",
  "Gambia": "ガンビア",
  "Georgia": "ジョージア",
  "Germany": "ドイツ",
  "Ghana": "ガーナ",
  "Gibraltar": "ジブラルタル",
  "Greece": "ギリシャ",
  "Greenland": "グリーンランド",
  "Grenada": "グレナダ",
  "Guadeloupe": "グアドループ",
  "Guam": "グアム",
  "Guatemala": "グアテマラ",
  "Guernsey": "ガーンジー",
  "Guinea": "ギニア",
  "Guinea-Bissau": "ギニアビサウ",
  "Guyana": "ガイアナ",
  "Haiti": "ハイチ",
  "Heard Island and Mcdonald Islands": "ハード島・マクドナルド諸島",
  "Holy See (Vatican City State)": "バチカン市国",
  "Honduras": "ホンジュラス",
  "Hong Kong": "香港",
  "Hungary": "ハンガリー",
  "Iceland": "アイスランド",
  "India": "インド",
  "Indonesia": "インドネシア",
  "Iran, Islamic Republic Of": "イラン",
  "Iraq": "イラク",
  "Ireland": "アイルランド",
  "Isle of Man": "マン島",
  "Israel": "イスラエル",
  "Italy": "イタリア",
  "Jamaica": "ジャマイカ",
  "Japan": "日本",
  "Jersey": "ジャージー",
  "Jordan": "ヨルダン",
  "Kazakhstan": "カザフスタン",
  "Kenya": "ケニア",
  "Kiribati": "キリバス",
  "Korea, Democratic People Republic of": "北朝鮮",
  "Korea, Republic of": "韓国",
  "Kuwait": "クウェート",
  "Kyrgyzstan": "キルギス",
  "Lao People Democratic Republic": "ラオス",
  "Latvia": "ラトビア",
  "Lebanon": "レバノン",
  "Lesotho": "レソト",
  "Liberia": "リベリア",
  "Libyan Arab Jamahiriya": "リビア",
  "Liechtenstein": "リヒテンシュタイン",
  "Lithuania": "リトアニア",
  "Luxembourg": "ルクセンブルク",
  "Macao": "マカオ",
  "Macedonia, The Former Yugoslav Republic of": "北マケドニア",
  "Madagascar": "マダガスカル",
  "Malawi": "マラウイ",
  "Malaysia": "マレーシア",
  "Maldives": "モルディブ",
  "Mali": "マリ",
  "Malta": "マルタ",
  "Marshall Islands": "マーシャル諸島",
  "Martinique": "マルティニーク",
  "Mauritania": "モーリタニア",
  "Mauritius": "モーリシャス",
  "Mayotte": "マヨット",
  "Mexico": "メキシコ",
  "Micronesia, Federated States of": "ミクロネシア連邦",
  "Moldova, Republic of": "モルドバ",
  "Monaco": "モナコ",
  "Mongolia": "モンゴル",
  "Montserrat": "モントセラト",
  "Morocco": "モロッコ",
  "Mozambique": "モザンビーク",
  "Myanmar": "ミャンマー (ビルマ)",
  "Namibia": "ナミビア",
  "Nauru": "ナウル",
  "Nepal": "ネパール",
  "Netherlands": "オランダ",
  "Netherlands Antilles": "オランダ領アンティル",
  "New Caledonia": "ニューカレドニア",
  "New Zealand": "ニュージーランド",
  "Nicaragua": "ニカラグア",
  "Niger": "ニジェール",
  "Nigeria": "ナイジェリア",
  "Niue": "ニウエ",
  "Norfolk Island": "ノーフォーク島",
  "Northern Mariana Islands": "北マリアナ諸島",
  "Norway": "ノルウェー",
  "Oman": "オマーン",
  "Pakistan": "パキスタン",
  "Palau": "パラオ",
  "Palestinian Territory, Occupied": "パレスチナ",
  "Panama": "パナマ",
  "Papua New Guinea": "パプアニューギニア",
  "Paraguay": "パラグアイ",
  "Peru": "ペルー",
  "Philippines": "フィリピン",
  "Pitcairn": "ピトケアン諸島",
  "Poland": "ポーランド",
  "Portugal": "ポルトガル",
  "Puerto Rico": "プエルトリコ",
  "Qatar": "カタール",
  "Reunion": "レユニオン",
  "Romania": "ルーマニア",
  "Russian Federation": "ロシア",
  "RWANDA": "ルワンダ",
  "Saint Helena": "セントヘレナ",
  "Saint Kitts and Nevis": "セントクリストファー・ネーヴィス",
  "Saint Lucia": "セントルシア",
  "Saint Pierre and Miquelon": "サンピエール島・ミクロン島",
  "Saint Vincent and the Grenadines": "セントビンセント及びグレナディーン諸島",
  "Samoa": "サモア",
  "San Marino": "サンマリノ",
  "Sao Tome and Principe": "サントメ・プリンシペ",
  "Saudi Arabia": "サウジアラビア",
  "Senegal": "セネガル",
  "Serbia and Montenegro": "セルビア・モンテネグロ",
  "Seychelles": "セーシェル",
  "Sierra Leone": "シエラレオネ",
  "Singapore": "シンガポール",
  "Slovakia": "スロバキア",
  "Slovenia": "スロベニア",
  "Solomon Islands": "ソロモン諸島",
  "Somalia": "ソマリア",
  "South Africa": "南アフリカ",
  "South Georgia and the South Sandwich Islands": "サウスジョージア・サウスサンドウィッチ諸島",
  "Spain": "スペイン",
  "Sri Lanka": "スリランカ",
  "Sudan": "スーダン",
  "Suriname": "スリナム",
  "Svalbard and Jan Mayen": "スバールバル諸島・ヤンマイエン島",
  "Swaziland": "エスワティニ",
  "Sweden": "スウェーデン",
  "Switzerland": "スイス",
  "Syrian Arab Republic": "シリア",
  "Taiwan, Province of China": "台湾",
  "Tajikistan": "タジキスタン",
  "Tanzania, United Republic of": "タンザニア",
  "Thailand": "タイ",
  "Timor-Leste": "東ティモール",
  "Togo": "トーゴ",
  "Tokelau": "トケラウ",
  "Tonga": "トンガ",
  "Trinidad and Tobago": "トリニダード・トバゴ",
  "Tunisia": "チュニジア",
  "Turkey": "トルコ",
  "Turkmenistan": "トルクメニスタン",
  "Turks and Caicos Islands": "タークス・カイコス諸島",
  "Tuvalu": "ツバル",
  "Uganda": "ウガンダ",
  "Ukraine": "ウクライナ",
  "United Arab Emirates": "アラブ首長国連邦",
  "United Kingdom": "イギリス",
  "United States": "アメリカ合衆国",
  "United States Minor Outlying Islands": "合衆国領有小離島",
  "Uruguay": "ウルグアイ",
  "Uzbekistan": "ウズベキスタン",
  "Vanuatu": "バヌアツ",
  "Venezuela": "ベネズエラ",
  "Viet Nam": "ベトナム",
  "Virgin Islands, British": "英領ヴァージン諸島",
  "Virgin Islands, U.S.": "米領ヴァージン諸島",
  "Wallis and Futuna": "ウォリス・フツナ",
  "Western Sahara": "西サハラ",
  "Yemen": "イエメン",
  "Zambia": "ザンビア",
  "Zimbabwe": "ジンバブエ",
  "Your client's account · used for {count} event": {
    "other": "クライアントのアカウント・{count}件のイベントで使用"
  },
  "Your client's account": "クライアントのアカウント",
  "Your account · used for {count} event": {
    "other": "あなたのアカウント・{count}件のイベントで使用"
  },
  "Your account": "あなたのアカウント",
  "Used for {count} event": {
    "other": "{count}件のイベントで使用"
  },
  "Connected before": "以前に接続済み",
  "Ticket payouts for “{event}” will go to {account}, your client's Stripe account. Use it only for this client's events.": "「{event}」のチケット売上は、クライアントのStripeアカウントである{account}に入金されます。このクライアントのイベントにのみ使用してください。",
  "Ticket payouts for “{event}” will go to {account}.": "「{event}」のチケット売上は{account}に入金されます。",
  "Use this account": "このアカウントを使用",
  "Couldn't use this Stripe account": "このStripeアカウントを使用できませんでした",
  "Use a Stripe account you've connected before": "以前接続したStripeアカウントを使用",
  "Or connect another Stripe account:": "または、別のStripeアカウントを接続：",
  "Connect another Stripe account": "別のStripeアカウントを接続"
}
